/**
 * Created by rathompson on 3/1/22
 * File: SendInviteForm
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useCallback, useEffect, useMemo, useState } from 'react'
import { Body, Bold, Button, LoadingIcon, Input } from '@panwds/react-ui'
import {
  BUTTON_SEND_INVITE,
  LABEL_FIRST_NAME,
  LABEL_LAST_NAME, LABEL_SEND_INVITE,
  PLACEHOLDER_FIRST_NAME,
  PLACEHOLDER_LAST_NAME,
} from '../../../../../../constants/LabelConstants'
import IAMService from '../../../../../../services/IAMService'

const ConnectedButton = ({ loading, onSubmit, inviteSent, formLoading, firstname, lastname }) => {
  // const { formState, getValues } = useFormContext()
  // const { isValid } = formState
  const isValid = Boolean(firstname) && Boolean(lastname)

  const onClick = useCallback(() => {
    onSubmit()
  }, [onSubmit])

  return (
    <Button
      icon={loading && <LoadingIcon/>}
      onClick={onClick}
      appearance='secondary'
      addClassName='tw-float-right tw-mt-1'
      disabled={!!inviteSent || formLoading || !isValid}
    >{BUTTON_SEND_INVITE}</Button>
  )
}

const SendInviteForm = ({ setError, email, tsg_id, inviteSent, setInviteSent, validateLoading, isLoading }) => {

  const [loading, setLoading] = useState(false)
  const [firstname, setFirstName] = useState('')
  const [lastname, setLastName] = useState('')

  useEffect(() => {
    return () => {
      setFirstName('')
      setLastName('')
    }
  }, [])

  const onSubmit = useCallback(async () => {
    try {
      setError('')
      setLoading(true)
      await IAMService.ping.register(tsg_id, { email, firstname, lastname })
      setInviteSent(true)
    }
    catch (error) {
      setError(error.message)
    }
    setLoading(false)
  }, [firstname, lastname, email, setError, setInviteSent, tsg_id])

  const formLoading = useMemo(() => loading || validateLoading || isLoading, [isLoading, loading, validateLoading])

  return (
    <div>
      <div className='tw-flex tw-w-full tw-justify-between tw-gap-2 tw-mt-1'>
        <div className='tw-flex-1'>
          <Bold appearance="semibold">{LABEL_FIRST_NAME}</Bold>
          <Input
            name={'firstname'}
            label={'firstname'}
            value={firstname}
            addClassName="tw-mt-1"
            placeholder={PLACEHOLDER_FIRST_NAME}
            disabled={formLoading || inviteSent}
            onChange={event => setFirstName(event.currentTarget.value)}
          />
        </div>
        <div className='tw-flex-1'>
          <Bold appearance="semibold">{LABEL_LAST_NAME}</Bold>
          <Input
            name={'lastname'}
            label={'lastname'}
            value={lastname}
            addClassName="tw-mt-1"
            placeholder={PLACEHOLDER_LAST_NAME}
            disabled={formLoading || inviteSent}
            onChange={event => setLastName(event.currentTarget.value)}
          />
        </div>
      </div>
      <Body size='xs' appearance='secondary'>{LABEL_SEND_INVITE}</Body>
      <ConnectedButton loading={loading} {...{ onSubmit, inviteSent, formLoading, firstname, lastname }}/>
    </div>
  )
}

SendInviteForm.propTypes = {}
export default SendInviteForm
